import { render, staticRenderFns } from "./DeliveryMetersCard.vue?vue&type=template&id=9bdfc488"
import script from "./DeliveryMetersCard.vue?vue&type=script&lang=ts"
export * from "./DeliveryMetersCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports